import { render, staticRenderFns } from "./icon-example.mpx?vue&type=template&id=1681378b&isComponent&outputPath=components%2Ficon-example76a0aad7%2Findex"
import script from "./icon-example.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Ficon-example76a0aad7%2Findex"
export * from "./icon-example.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Ficon-example76a0aad7%2Findex"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports